/**
 *
 */

var Gsap = (function($) {
  function initGsap() {
    gsap.registerPlugin(ScrollTrigger);
  }

  function initPipelineAnimation() {
    const $blocks = $(".pipeline-table-body-block");
    if (!$blocks.length) return;

    // 1) Guardar widths finales desde data-progress
    const finalWidths = $blocks
      .map(function() {
        const progress = $(this).data("progress");

        // Si no hay valor, devolvemos 0%
        if (progress === undefined || progress === "") return "0%";

        return `${progress}%`;
      })
      .get();

    // 2) Set inicial
    gsap.set($blocks.toArray(), {
      width: 0,
      overflow: "hidden"
    });

    // 3) Animación con stagger + ScrollTrigger
    gsap.to($blocks.toArray(), {
      width: i => finalWidths[i],
      duration: 1.1,
      ease: "power3.out",
      stagger: 0.15,
      scrollTrigger: {
        trigger: ".pipeline-table-body",
        start: "top 75%",
        toggleActions: "play none none none"
        // markers: true,
      }
    });

    // 4) Refresh al cargar todo
    $(window).on("load", function() {
      ScrollTrigger.refresh();
    });
  }

  function init() {
    if (!$(".home").length) {
      return;
    }

    initGsap();
    initPipelineAnimation();
  }

  return {
    init: init
  };
})(jQuery);

jQuery(document).ready(Gsap.init);
